import { IPropsWithChildren } from '@omaze/app';
import React, { ReactElement } from 'react';

import styles from './LinkList.styles.css';

export function ListTitle (props: IPropsWithChildren): ReactElement {
    return (
        <li className={`text-med font-bold capitalize mb-3 leading-7 ${styles.li}`}>
            {props.children}
        </li>
    );
}
